// extracted by mini-css-extract-plugin
export default {"ProductProperty":"ProductProperty__ProductProperty___FzHQc","label":"ProductProperty__label___ViMyw","value":"ProductProperty__value___vkR_K"};